export default __webpack_public_path__ + "static/media/wallet.e6eee560.svg";